import { render, staticRenderFns } from "./AccessorialsResponsive.vue?vue&type=template&id=6bc89d85&scoped=true"
import script from "./AccessorialsResponsive.vue?vue&type=script&lang=js"
export * from "./AccessorialsResponsive.vue?vue&type=script&lang=js"
import style0 from "./AccessorialsResponsive.vue?vue&type=style&index=0&id=6bc89d85&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc89d85",
  null
  
)

export default component.exports